import zswColors from '../../assets/scss/zsw_colors.module.scss';
import zswLogo  from "!file-loader!../../assets/img/zsw_logo.svg"

const zswTheme = {
    institutionName: "Zentrum für Sonnenenergie- und Wasserstoffforschung (BW)",
    abbreviation: "ZSW",
    colors: zswColors,
    logo: zswLogo,
    impressum: "",
    dataProtection: "https://www.zsw-bw.de/footer/datenschutz.html"
}

export default zswTheme